import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=b9447c02&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9447c02')) {
      api.createRecord('b9447c02', component.options)
    } else {
      api.reload('b9447c02', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=b9447c02&", function () {
      api.rerender('b9447c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8FuLb7EL3yBka/JS/comp/IncreaseNumber.vue"
export default component.exports